import store from 'store';
import { fetchProfileAsync } from 'store/actions/profile-actions';

const loadProfile = async (): Promise<void> => {
  await store.dispatch(fetchProfileAsync());
};

export default loadProfile;
